<template>
  <div>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.steamMeter"
          :label="$t(`treatmentProgram.steam.step5.steamMeter`)"
          :items="yesNo"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.steamMeterConnectToController"
          :label="$t(`treatmentProgram.steam.step5.connectToController`)"
          :items="yesNo"
          :disabled="!data.steamMeter"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.makeupWaterMeter"
          :label="$t(`treatmentProgram.steam.step5.makeupWaterMeter`)"
          :items="yesNo"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.makeupWaterMeterConnectToController"
          :label="$t(`treatmentProgram.steam.step5.connectToController`)"
          :items="yesNo"
          :disabled="!data.makeupWaterMeter"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.blowdownWaterMeter"
          :label="$t(`treatmentProgram.steam.step5.blowdownWaterMeter`)"
          :items="yesNo"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.blowdownWaterMeterConnectToController"
          :label="$t(`treatmentProgram.steam.step5.connectToController`)"
          :items="yesNo"
          :disabled="!data.blowdownWaterMeter"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.condensateMeter"
          :label="$t(`treatmentProgram.steam.step5.condensateMeter`)"
          :items="yesNo"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.condensateMeterConnectToController"
          :label="$t(`treatmentProgram.steam.step5.connectToController`)"
          :items="yesNo"
          :disabled="!data.condensateMeter"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';

export default {
    props: {
        programControl: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
            keys: [
                'blowdown',
                'conductivity',
                'ph',
                'temperature',
                'orp',
                'fluorometer',
                'corossionMeter',
                'internetConnection',
                'other',
            ],
        };
    },
    computed: {
        yesNo() {
            return ['yes', 'no'].map(key => ({
                name: this.$t(`treatmentProgram.steam.step3.${key}`),
                key: key === 'yes',
            }));
        },
    },
    watch: {
        programControl: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.programControl) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { programControl: this.data });
        },
    },
};
</script>
  <style lang="scss" scoped>
  .xPadding{
    padding: 0 6rem;
  }
  @media screen and (max-width: 600px) {
     .xPadding{
        padding: 0;
      }
  }
  </style>
